<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>缴费管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form
        inline
        :model="query"
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList();"
      >
        <el-form-item label="搜索" prop="key">
          <el-input v-model="key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item label="学校" label-width="80px" style="margin-left:-15px;">
          <el-select v-model="query.schid" filterable @change="schoolClick()">
            <el-option label="请选择" value></el-option>
            <el-option
              v-for="item in schoollist"
              :label="item.label"
              :value="item.value"
              :key="item.value"
              placeholder="请选择"
            ></el-option>
          </el-select>
        </el-form-item>
        <SelectAbroad v-on:selabroad="function(str){query.abroadTime=str;selList();}"></SelectAbroad>
        <el-form-item label="缴费时间" label-width="80px" style="margin-left:8px;">
          <el-date-picker
            v-model="query.daterange"
            @change="selList()"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="顾问" label-width="80px" style="margin-left:-15px;">
          <DeptRoleTeacherSelect v-model="query.adviserID" dept="留学" placeholder="请选择顾问" @change="selList()" />
        </el-form-item>
        <el-form-item label="营销" label-width="80px" style="margin-left:-15px;">
          <DeptRoleTeacherSelect v-model="query.marketID" dept="留学" placeholder="请选择营销" @change="selList()" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList();">查询</el-button>
          <el-button type="success" @click="exportClick();">导出</el-button>
        </el-form-item>
      </el-form>
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>缴费列表</span>
        </div>
        <!-- 列表定义 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          show-summary
          :summary-method="getSummaries"
          style="width:100%;"
          @sort-change="sortChange"
          @filter-change="filterTag"
        >
          <el-table-column prop="paymentDate" label="缴费时间"></el-table-column>
          <el-table-column prop="realName" label="姓名"></el-table-column>
          <el-table-column prop="abroadDate" label="留学时间"></el-table-column>
          <el-table-column  label="申请学校">
            <template slot-scope="scope">
              <span  :style="{color:scope.row.applySchID==null?'red':''}">{{scope.row.applySchool}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="xklYen" label="选考料日元"></el-table-column>
          <el-table-column prop="xklYuan" label="选考料/￥"></el-table-column>
          <el-table-column prop="otherFees" label="其他费用"></el-table-column>
          <el-table-column prop="commissionYen" label="佣金日元"></el-table-column>
          <el-table-column prop="commissionYuan" label="佣金/￥"></el-table-column>
          <el-table-column prop="adviserName" label="顾问"></el-table-column>
          <el-table-column prop="percentage" label="顾问提成/￥"></el-table-column>
          
          <el-table-column prop="percentnum" label="顾问提成比例"></el-table-column>
          <el-table-column prop="marketName" label="营销"></el-table-column>
          <el-table-column prop="marketPercentage" label="营销提成/￥"></el-table-column>
          <!-- <el-table-column prop="tenement" label="是否租房"></el-table-column>
          <el-table-column prop="privateSchool" label="报私塾"></el-table-column>-->
          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>

                <el-tooltip content="标记退出" placement="top" v-if="userIsAdmain">
                  <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    @click="deleteClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页条 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50,100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 操作对话框 -->
    <el-dialog :title="form.id>0?'编辑缴费信息':'添加缴费信息'" :visible.sync="dialogVisible" @open="dialogopen">
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm('form')"
      >
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="缴费时间" prop="paymentDate" :rules="[{required:true,message:'不能为空'}]">
              <el-date-picker
                v-model="form.paymentDate"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="请选择缴费时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请学校" prop="applySchID" :rules="[{required:true,message:'不能为空'}]">
              <el-select
                v-model="form.applySchID"
                placeholder="请选择申请学校"
                filterable
                style="width:100%;"
                @change="selectSchoolClick"
              >
                <el-option
                  v-for="item in schoollist"
                  :label="item.label"
                  :value="item.value"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="留学时间" prop="abroadDate" :rules="[{required:true,message:'不能为空'}]">
              <el-input v-model="form.abroadDate" readonly></el-input>
              <el-button
                style="position:absolute;margin-left:-71px;height:38px;top:1px;"
                @click="abroadTimeDialog=true"
              >选择</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="文案老师" prop="documentID" :rules="[{required:true,message:'不能为空'}]">
              <el-select v-model="form.documentID" placeholder="请选择" filterable>
                <el-option
                  v-for="item in documentList"
                  :label="item.realName"
                  :value="item.userID"
                  :key="item.userID"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="选考料" prop="xklYen" :rules="[{required:true,message:'不能为空'}]">
              <el-input v-model.number="form.xklYen" type="number" placeholder="选考料日元">
                <template slot="append">日元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="选考料" prop="xklYuan" :rules="[{required:true,message:'不能为空'}]">
              <el-input v-model.number="form.xklYuan" type="number" placeholder="选考料人民币">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="其他费用" prop="otherFees" :rules="[{required:false,message:'不能为空'}]">
          <el-input type="text" v-model="form.otherFees" placeholder="请输入其他费用">
          </el-input>
        </el-form-item>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="佣金" prop="commissionYen" :rules="[{required:true,message:'不能为空'}]">
              <el-input
                v-model.number="form.commissionYen"
                type="number"
                placeholder="佣金日元"
                @input="numberChange(form.commissionYen,'commissionYuan')"
              >
                <template slot="append">日元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="佣金"
              prop="commissionYuan"
              :rules="[{required:true,message:'不能为空'}]"
            >
              <el-input v-model.number="form.commissionYuan" type="number" placeholder="佣金元">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="顾问提成" prop="percentage" :rules="[{required:true,message:'不能为空'}]">
              <el-input v-model.number="form.percentage" type="number" placeholder="顾问提成">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="顾问提成比例" prop="percentnum">
              <el-input
                v-model.number="form.percentnum"
                type="number"
                placeholder="顾问提成比例"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="营销提成"
              prop="marketPercentage"
              :rules="[{required:true,message:'不能为空'}]"
            >
              <el-input v-model.number="form.marketPercentage" type="number" placeholder="顾问提成">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="是否租房" prop="tenement">
          <el-input v-model="form.tenement" placeholder="请输入是否租房"></el-input>
        </el-form-item>
        <el-form-item label="是否报塾" prop="privateSchool">
          <el-input v-model="form.privateSchool" placeholder="请输入是否报塾"></el-input>
        </el-form-item>
        <!-- 设置回访任务 -->
        <!-- <template v-if="form.operateState==2">
          <el-divider content-position="left" style="padding:20px 0px;">老师回访 (学生关怀)</el-divider>
          <el-form-item label="回访时间" prop="day" :rules="[{required:true,message:'不能为空'}]">
            <el-col :span="5">
              <el-input v-model="form.noticeDate" readonly></el-input>
            </el-col>
            <el-col :span="1" style="text-align:center;">-</el-col>
            <el-col :span="5">
              <el-select v-model="form.day" placeholder="请选择天" filterable style="width:100%;">
                <el-option v-for="item in dayList" :label="item" :value="item" :key="item"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="回访人" prop="adviserID" :rules="[{required:true,message:'不能为空'}]">
                <el-select v-model="form.adviserID" placeholder="请选择回访人" filterable>
                  <el-option
                    v-for="item in adviserList"
                    :label="item.realName"
                    :value="item.userID"
                    :key="item.userID"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </template>-->
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 选择留学时间对话框 -->
    <el-dialog title="选择留学时间" :visible.sync="abroadTimeDialog">
      <el-form>
        <el-form-item label="年份" prop="year">
          <el-select v-model="apply.year" placeholder="请选择年份" filterable style="width:100%;">
            <el-option v-for="item in yearList" :label="item+'年'" :value="item" :key="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="月份" prop="month">
          <el-select v-model="apply.month" placeholder="请选月份" filterable style="width:100%;">
            <el-option v-for="item in [1,4,7,10]" :label="item+'月'" :value="item" :key="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="abroadTimeDialog = false;form.abroadDate=apply.year+'-'+apply.month;form.noticeDate=apply.year+'-'+(apply.month+1);initDayList();"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import dateHelper from "@/plugins/dateHelper.js";
import user from "@/plugins/user.js";
import SelectAbroad from "@/components/SelectAbroad";
import DeptRoleTeacherSelect from "@/components/DeptRoleTeacherSelect.vue";

export default {
  data() {
    return {
      stuid: 0,
      key: "",
      state: "",
      query: {}, //对象
      userIsAdmain: user.isAdmin(),
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      submiting: false,
      id: 0,
      roleVisible: false, //是否显示角色对话框
      treeData: [], //权限树结构
      checkedKeys: [], //选中id列表
      stustatelist: [
        { id: "a", name: "a" },
        { id: "b", name: "b" },
        { id: "c", name: "c" },
        { id: "d", name: "d" },
        { id: "e", name: "e" }
      ], //跟进状态
      applymonthlist: [
        { id: "一月", name: "一月" },
        { id: "四月", name: "四月" },
        { id: "七月", name: "七月" },
        { id: "十月", name: "十月" }
      ], //申请时间
      schoollist: [], //获取学校
      adviserList: [], //获取回访人  顾问老师
      documentList: [], //获取回访人  文案老师
      marketList: [],
      abroadTimeDialog: false,
      yearList: dateHelper.getYearList(),
      dayList: [],
      apply: {}, //申请时间的对象
      abroadTimeDialog2: false,
      collect: [], //汇总数据
      daterange: [], //时间筛选
      config:{},//配置文件
    };
  },
  components: {
    SelectAbroad,
    DeptRoleTeacherSelect
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      //刷新列表
      this.getList();
    },
    //按学校查询
    schoolClick: function() {
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.form.sort = sortColumn.prop;
      this.form.order = sortColumn.order;
      //刷新列表
      this.getList();
    },
    // 获取配置文件
    getConfig(){
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      var link = url.getSys("getconfig");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.config = data;
      });
    },
    dialogopen(){
      this.numberChange(this.form.commissionYen, 'commissionYuan');
    },
    getList: function() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      if (_this.query.daterange) {
        params.payStart = _this.query.daterange[0];
        params.payEnd = _this.query.daterange[1];
      } else {
        params.payStart = "";
        params.payEnd = "";
      }
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      params.key = _this.key;
      var link = url.getStu("getlist_payment");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
        _this.collect = data.collect;
      });
    },
    //导出操作
    exportClick() {
      var _this = this;
      var params = _this.query;
      params.key = _this.key;

      var result = [];
      for (var item in params) {
        if (params[item]) {
          result.push(item + "=" + params[item]);
        }
      }
      var link = url.getStu("ExportPay") + "?" + result.join("&");
      //console.info(link);
      window.open(link, "_blank");
    },
    //获取学校
    school: function() {
      var _this = this;
      var link = url.getCommon("getschool");
      $.get(link, {}, data => {
        _this.schoollist = data;
      });
    },
    // 获取回访人：顾问/营销不再按板块，用所有启用用户；文案老师单独接口
    noticeuserlist: function() {
      var _this = this;
      $.get(url.getStu("getenableusers"), res => {
        var list = res || [];
        _this.adviserList = list;
        _this.marketList = list;
      });
      $.get(url.getStu("getdocument"), res => {
        _this.documentList = res;
      });
    },
    //搜索查询
    selList: function() {
      this.currentPage4 = 1;
      this.getList();
    },
    //提交表单
    submitForm(formName) {
      var _this = this;
      this.$refs.form.validate(valid => {
        if (valid) {
          //询问操作
          this.$confirm("确定要修改吗", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              var link = url.getStu("update_payment");
              var info = Object.assign({}, this.form);
              info.noticeDate = _this.form.noticeDate + "-" + _this.form.day;
              this.submiting = true;
              //提交后台添加
              $.post(link, info, res => {
                _this.submiting = false;
                if (res.status) {
                  _this.dialogVisible = false;
                  _this.getList();
                  _this.$message({
                    type: "success",
                    message: res.msg
                  });
                } else {
                  _this.$message({
                    type: "error",
                    message: res.msg
                  });
                }
              });
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    //编辑
    editClick: function(row) {
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
      if (row.abroadDate) {
        this.apply = {
          year: row.abroadDate.split("-")[0],
          month: row.abroadDate.split("-")[1]
        };
        this.form.noticeDate =
          this.apply.year + "-" + (parseInt(this.apply.month) + 1);
        this.initDayList();
      }

      //选考料
      if(this.form.xklYen==null){
        var schList=this.schoollist;
        var thisScholl=schList.find(q=>q.value==row.applySchID);
        if(thisScholl){
          this.form.xklYen=thisScholl.xklAmount||0;
        }
      }
    },
    initDayList: function() {
      var _this = this;
      var list = dateHelper.getDayList(this.form.noticeDate);
      this.dayList = list;
    },
    //标记退出
    deleteClick: function(row) {
      var id = row.id;
      var _this = this;
      this.$confirm("确定要标记退出吗，数据将不可恢复", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var link = url.getStu("signout");
          $.post(link, { id: id }, res => {
            if (res.status) {
              _this.$message({
                type: "success",
                message: res.msg
              });
              _this.getList();
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        })
        .catch(() => {});
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      // columns.forEach((column, index) => {
      //   if (index === 0) {
      //     sums[index] = '总价';
      //     return;
      //   }
      //   const values = data.map(item => Number(item[column.property]));
      //   if (!values.every(value => isNaN(value))) {
      //     sums[index] = values.reduce((prev, curr) => {
      //       const value = Number(curr);
      //       if (!isNaN(value)) {
      //         return prev + curr;
      //       } else {
      //         return prev;
      //       }
      //     }, 0);
      //     sums[index] += ' 元';
      //   } else {
      //     sums[index] = 'N/A';
      //   }
      // });

      return this.collect;
    },
    //选择喧嚣
    selectSchoolClick(val) {
      var thisItem = this.schoollist.find(q => q.value == val);
      var amount = thisItem.xklAmount || 0;

      //this.form.xklYuan = amount * 0.06;
      this.form.xklYen = amount;
    },
    numberChange(val, target) {
      var config=this.config;
      console.log('config',config)
      this.form[target] = (val * config.exchangeRate/100).toFixed(2);
    }
  },
  mounted() {
    var _this = this;
    //接收参数id
    _this.stuid = this.$route.query.id;
    if (_this.stuid > 0) {
      _this.getList();
    } else {
      _this.form = {};
    }
    //获取配置文件
    _this.getConfig();

    //获取服务器列表
    _this.getList();
    //获取学校
    _this.school();
    //获取回访人  顾问老师
    _this.noticeuserlist();
  }
};
</script>

